export default __webpack_public_path__ + "static/hero_business_mob_img_3-ccab3990b2a546dc5bcfffa2ae0cbc52.png";